import * as React from 'react';
import { Loader } from '../Components/Loader';
import { LoginState } from '../Models/ApplicationInterfaces';


interface Props{
    changeState: (_:LoginState) => void;
    setLoading: (_:boolean) => void;
}

export class LobbyScreen extends React.Component<Props> {

    // TODO get the player list in the component did mount
    public render() {
        return <Loader message="In Lobby"/>
    }

}


// WEBPACK FOOTER //
// ./src/Views/Lobby.tsx